import { observable, action, toJS, runInAction } from "mobx";
import { message } from "antd";
class Store {
    @observable visible = false;
    @observable loading = false;
    @observable data = {
        billing_name: "",
        billing_bank: "",
        billing_number: "",
        billing_bank_account: "",
        billing_tel: "",
        billing_addr: "",
        out_trade_no: '',
        billing_invoice: "",
        company_phone: "",
        company_addr: "",
    };

    @action
    onChange = (name, value = '') => {
        this.data[name] = value;
    }

    @action
    onShow = (item) => {
        this.data = {
            out_trade_no: item.out_trade_no,
            billing_name: item.name,
            billing_bank: item.billing_bank,
            billing_number: item.billing_number,
            billing_bank_account: item.billing_bank_account,
            billing_tel: item.tel,
            billing_invoice: item.billing_invoice,
            email: item.email,
            company_phone: item.company_phone,
            company_addr: item.company_addr,
        };
        this.visible = true;
    }

    @action
    onCancel = () => {
        this.visible = false;
        this.clearData();
    }

    @action
    onOk = async (getData) => {
        const data = toJS(this.data);

        if (!/^[a-zA-Z0-9_.-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/.test(data.email)) {
            message.error('邮箱格式不正确!');
            return
        }

        if (!data.billing_bank || !data.billing_bank_account) {
            message.error('开户行信息不能为空!');
            return
        }

        if (!data.billing_number) {
            message.error('请输入纳税人识别号!');
            return
        }

        if (!data.company_phone) {
            message.error('请输入公司电话!');
            return
        }
        this.loading = await true;
        let dataFrom = new FormData();
        for (const key in data) {
            if (data.hasOwnProperty(key)) {
                dataFrom.append(key, data[key]);
            }
        }

        let headres = {
            method: 'post',
            credentials: 'include',
            headers: {},
            body: dataFrom
        }
        try {
            const res = await fetch('/applyBilling', headres);
            const x = await res.json();
            this.loading = false;
            if (x.status == 1) {
                message.info('申请开票成功！');
                runInAction(() => {
                    this.visible = false;
                    this.clearData();
                });
                getData && getData();
                return
            }
            message.error(x.msg);
        } catch (error) {
            message.error(error.message);
            this.loading = false;
            console.error(error);
        }
    }
    @action clearData = () => {
        this.data = {
            billing_name: "",
            billing_bank: "",
            billing_number: "",
            billing_bank_account: "",
            billing_tel: "",
            billing_addr: "",
            out_trade_no: '',
            billing_invoice: "",
            company_phone: "",
            company_addr: ""
        };
    }
}

const applybilling = new Store();

export default applybilling;


// WEBPACK FOOTER //
// ./src/components/user/ApplyBilling/store.js